module.exports = __webpack_public_path__ + "static/media/partner-icon-sundial-greyscale.b3992290.svg";